import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const LINKS = [
  { href: "#story", key: "nav.story" },
  { href: "#services-panel", key: "nav.services" },
  { href: "#process", key: "nav.process" },
  { href: "#reviews", key: "reviews.nav" },
  { href: "#faq", key: "nav.faq" },
];

export default function SiteNav() {
  const { t, i18n } = useTranslation();
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > window.innerHeight * 0.75);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const setLang = (lng: string) => {
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  const waText = i18n.language === "es" ? t("contact.waTextEs") : t("contact.waTextEn");
  const waHref = `https://wa.me/59893855338?text=${encodeURIComponent(waText)}`;

  return (
    <header className={`site-nav ${solid ? "is-solid" : ""}`}>
      <a
        href="#overview"
        className="nav-brand flex items-center gap-3 min-w-0"
        onClick={() => setOpen(false)}
      >
        <span className="nav-logo">
          <img
            src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/4926e2d57954fd8852e13e9574e5a955.jpeg"
            alt="Facundo Yoldi — Enfermería"
            width={48}
            height={48}
          />
        </span>
        <span className="flex flex-col leading-none min-w-0">
          <span className="text-[15px] font-bold tracking-tight nav-ink whitespace-nowrap">
            Facundo Yoldi
          </span>
          <span className="mono text-[9px] tracking-[.18em] uppercase mt-1 nav-muted whitespace-nowrap nav-tagline">
            {t("footer.tag")}
          </span>
        </span>
      </a>

      <nav className="hidden lg:flex items-center gap-8">
        {LINKS.map((l) => (
          <a key={l.href} href={l.href} className="nav-link">
            {t(l.key)}
          </a>
        ))}
        <a href="#contact" className="nav-link nav-link-accent">
          {t("nav.contact")}
        </a>
      </nav>

      <div className="flex items-center gap-2 flex-none">
        <div className="lang-switch" role="group" aria-label="Language">
          <button
            type="button"
            className="lang-switch-btn"
            data-active={i18n.language === "es"}
            aria-pressed={i18n.language === "es"}
            onClick={() => setLang("es")}
          >
            ES
          </button>
          <button
            type="button"
            className="lang-switch-btn"
            data-active={i18n.language !== "es"}
            aria-pressed={i18n.language !== "es"}
            onClick={() => setLang("en")}
          >
            EN
          </button>
        </div>
        <a
          href={waHref}
          target="_blank"
          rel="noopener noreferrer"
          className="cta nav-cta flex-none"
          aria-label={t("nav.call")}
        >
          <i className="ri-whatsapp-line text-[17px]" aria-hidden="true" />
          <span className="hidden md:inline whitespace-nowrap">{t("nav.call")}</span>
        </a>
        <button
          type="button"
          className="lg:hidden w-10 h-10 flex-none flex items-center justify-center rounded-md cursor-pointer nav-burger"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-[18px]" : "ri-menu-line text-[18px]"} aria-hidden="true" />
        </button>
      </div>

      {open && (
        <div
          className="absolute left-0 right-0 top-full lg:hidden flex flex-col gap-1 p-4"
          style={{
            background: "color-mix(in srgb, var(--bg) 97%, transparent)",
            borderBottom: "1px solid color-mix(in srgb, var(--text) 12%, transparent)",
          }}
        >
          {[...LINKS, { href: "#contact", key: "nav.contact" }].map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="py-2.5 text-[15px] font-medium"
              style={{ color: "var(--text)" }}
              onClick={() => setOpen(false)}
            >
              {t(l.key)}
            </a>
          ))}
          <a href={waHref} target="_blank" rel="noopener noreferrer" className="cta mt-2 justify-center">
            <i className="ri-whatsapp-line text-[17px]" aria-hidden="true" />
            {t("nav.call")}
          </a>
        </div>
      )}
    </header>
  );
}